export default "__VITE_ASSET__CG9A7$Yu__"